import api from "@/lib/api";

export async function fetchEvents(params = {}) {
  const { data } = await api.get("/events", { params });
  return data;
}
export async function fetchEvent(slug) {
  const { data } = await api.get(`/events/${slug}`);
  return data;
}
export async function submitRsvp(slug, payload) {
  const clean = {};
  for (const [k, v] of Object.entries(payload)) {
    if (typeof v === "string") {
      const t = v.trim();
      if (t !== "") clean[k] = t;
    } else if (v !== null && v !== undefined) {
      clean[k] = v;
    }
  }
  const { data } = await api.post(`/events/${slug}/rsvp`, clean);
  return data;
}
export async function adminListEvents(params = {}) {
  const { data } = await api.get("/admin/events", { params });
  return data;
}
export async function adminCreateEvent(payload) {
  const { data } = await api.post("/admin/events", payload);
  return data;
}
export async function adminUpdateEvent(id, payload) {
  const { data } = await api.put(`/admin/events/${id}`, payload);
  return data;
}
export async function adminDeleteEvent(id) {
  await api.delete(`/admin/events/${id}`);
}
